import Navbar from "../components/Navbar";
import Landing from "../components/Landing";
import Services from "../components/Services";
import About from "../components/About";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import { BsArrowUp } from "react-icons/bs";
import Testimonials from "../components/Testimonials";
const Home = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 200) {
      setVisible(true);
    } else if (scrolled <= 200) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  useEffect(() => {
    const scrolled = document.documentElement.scrollTop;
    if(scrolled > 0){
      scrollToTop()
    }
  }, [])
  
  return (
    <div className="relative">
      {/* <Navbar /> */}
      <Landing />
      <Services />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
      <div>
        {visible && (
          <div
            className="cursor-pointer bg-gradient-to-tr from-[#FE4904] to-[#F7164C] fixed bottom-10 right-10 w-[40px] h-[40px] flex items-center justify-center rounded-lg hover:from-[#F7164C] hover:to-[#FE4904]"
            onClick={scrollToTop}
          >
            <BsArrowUp color="white" size='24px' />
          </div>
        )}
      </div>
    </div>
  );
};
export default Home;
